import React, { useState } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { AppContextMenu, coreEvents, IfPermission } from '@folio/stripes/core';
import { CommandList, KeyboardShortcutsModal, NavList, NavListItem, NavListSection, HasCommand, checkScope } from '@folio/stripes/components';
import { CopyListPage, CreateListPage, EditListPage, ListInformationPage, ListPage, MissingAllEntityTypePermissionsPage } from './pages';
import { useRecordTypes } from './hooks';
import { t } from './services';
import { getStatusButtonElem, handleKeyCommand } from './utils';
import { commandsGeneral, AddCommand } from './keyboard-shortcuts';
export var ListsApp = function (props) {
    var path = props.match.path;
    var history = useHistory();
    var _a = useRecordTypes(), recordTypes = _a.recordTypes, isLoading = _a.isLoading;
    var _b = useState(false), showKeyboardShortcutsModal = _b[0], setShowKeyboardShortcutsModal = _b[1];
    var shortcutModalToggle = function (handleToggle) {
        handleToggle();
        setShowKeyboardShortcutsModal(true);
    };
    var focusStatus = function () {
        var el = getStatusButtonElem();
        if (el) {
            el.focus();
        }
        else {
            history.push('/lists');
        }
    };
    var focusStatusDropdown = function (handleToggle) {
        focusStatus();
        handleToggle === null || handleToggle === void 0 ? void 0 : handleToggle();
    };
    var shortcuts = [
        AddCommand.goToFilter(handleKeyCommand(focusStatus)),
        AddCommand.openModal(handleKeyCommand(function () {
            setShowKeyboardShortcutsModal(true);
        }))
    ];
    if (!isLoading && (recordTypes === null || recordTypes === void 0 ? void 0 : recordTypes.length) === 0) {
        return React.createElement(MissingAllEntityTypePermissionsPage, null);
    }
    return (React.createElement(CommandList, { commands: commandsGeneral },
        React.createElement(HasCommand, { commands: shortcuts, isWithinScope: checkScope, scope: document.body },
            React.createElement(AppContextMenu, null, function (handleToggle) { return (React.createElement(NavList, null,
                React.createElement(NavListSection, null,
                    React.createElement(NavListItem, { "data-testid": "list-app-home", onClick: function () { focusStatusDropdown(handleToggle); } }, t('app-menu.list-app-home')),
                    React.createElement(NavListItem, { "data-testid": "shortcuts", onClick: function () { shortcutModalToggle(handleToggle); } }, t('app-menu.keyboard-shortcuts'))))); }),
            React.createElement(Switch, null,
                React.createElement(Route, { path: path, exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.get" /* USER_PERMS.ReadList */ },
                        React.createElement(ListPage, null))); } }),
                React.createElement(Route, { path: "".concat(path, "/list/:id"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.get" /* USER_PERMS.ReadList */ },
                        React.createElement(ListInformationPage, null))); } }),
                React.createElement(Route, { path: "".concat(path, "/list/:id/edit"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.update" /* USER_PERMS.UpdateList */ },
                        React.createElement(EditListPage, null))); } }),
                React.createElement(Route, { path: "".concat(path, "/list/:id/copy"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.item.update" /* USER_PERMS.UpdateList */ },
                        React.createElement(CopyListPage, null))); } }),
                React.createElement(Route, { path: "".concat(path, "/new"), exact: true, render: function () { return (React.createElement(IfPermission, { perm: "lists.collection.post" /* USER_PERMS.CreateList */ },
                        React.createElement(CreateListPage, null))); } })),
            showKeyboardShortcutsModal && (React.createElement(KeyboardShortcutsModal, { allCommands: commandsGeneral, onClose: function () { setShowKeyboardShortcutsModal(false); }, open: true })))));
};
ListsApp.eventHandler = function (event) {
    if (event === coreEvents.LOGIN) {
        Object.keys(sessionStorage).forEach(function (key) {
            if (key.startsWith('@folio/lists')) {
                sessionStorage.removeItem(key);
            }
        });
    }
};
export default ListsApp;
